import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useAtomValue } from 'jotai';
import { selectedMetricSelector, metricSelector } from '@store/metricsChartContainer/selectors';
import { dimensionMetricsSelector, globalOrderBySelector } from '@store/trends/base/selectors';
import { setDimensionMetrics } from '@store/trends/base/actions';
import { filterNAMetricsAtom } from '@src/atoms/page';
import { selectedMetricChart, setMetrics } from '@store/metricsChartContainer/actions';
import { preserveOrder } from '@components/common/DnD/utils';
import { FlexFill } from '@components/common/Utils/Layout';
import { getMetricMetaByKey } from '@src/utils/metrics';
import { MetricTagsWrapper, StyledTag, TagWrapper } from './styled';

function MetricTags() {
  const primaryMetric = useSelector(selectedMetricSelector);
  const globalOrderByMetric = useSelector(globalOrderBySelector);
  const metrics = useSelector(dimensionMetricsSelector);
  const metricsList = useSelector(metricSelector);
  const metricsToNA = useAtomValue(filterNAMetricsAtom);

  const dispatch = useDispatch();

  const onCloseFn = (metric) => () => {
    const filteredMetrics = metrics.filter((m) => m !== metric);
    dispatch(setDimensionMetrics(filteredMetrics));
  };

  const onClearAll = () => {
    const filteredMetricsSet = new Set([primaryMetric, globalOrderByMetric]);
    dispatch(setDimensionMetrics(Array.from(filteredMetricsSet)));
  };

  const handleClickFn = (metric) => () => {
    // TODO: add set metrics to primary effect workflow?
    dispatch(selectedMetricChart(metric, null));
    dispatch(setMetrics(preserveOrder(metricsList, [...metricsList, metric])));
  };

  // skip order by metric tag if it's not the primary metric
  const filteredMetrics =
    primaryMetric === globalOrderByMetric
      ? metrics
      : metrics.filter((metric) => metric !== globalOrderByMetric);
  const showClearButton = filteredMetrics.length > 1; // metrics.some(metric => ![primaryMetric, globalOrderByMetric].includes(metric));

  return (
    <MetricTagsWrapper>
      <TagWrapper>
        {filteredMetrics.map((metric) => {
          const metricInfo = getMetricMetaByKey({ metricKey: metric });
          const metricInfoTitle = metricInfo.short;
          const canEdit = ![primaryMetric, globalOrderByMetric].includes(metric);
          const isNaMode: boolean = metricsToNA.includes(metric);
          return (
            <StyledTag
              key={metric}
              color={canEdit ? 'default' : 'blue'}
              closable={canEdit}
              onClose={onCloseFn(metric)}
              icon={undefined}
              $namode={isNaMode}
              contentEditable={false}
            >
              <span
                onClick={handleClickFn(metric)}
                style={isNaMode ? { opacity: 0.5, pointerEvents: 'none' } : {}}
              >
                {metricInfoTitle}
              </span>
            </StyledTag>
          );
        })}
        <FlexFill />
      </TagWrapper>
      {showClearButton && (
        <StyledTag
          onClick={onClearAll}
          style={{ cursor: 'pointer', margin: '0px 5px' }}
          $namode={false}
        >
          Clear All
        </StyledTag>
      )}
    </MetricTagsWrapper>
  );
}

export default MetricTags;
